import { render } from "./RecentInventories.vue?vue&type=template&id=6366715a"
import script from "./RecentInventories.vue?vue&type=script&lang=js"
export * from "./RecentInventories.vue?vue&type=script&lang=js"
script.render = render

export default script